import { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import io from 'socket.io-client';
import { updateCurrentTrip } from '../store/tripSlice';

const useSocket = (tripId) => {
  const socketRef = useRef();
  const dispatch = useDispatch();

  useEffect(() => {
    if (tripId) {
      socketRef.current = io(process.env.REACT_APP_SOCKET_URL);
      
      socketRef.current.emit('join-trip', tripId);
      
      socketRef.current.on('trip-updated', (data) => {
        dispatch(updateCurrentTrip(data.trip));
      });

      return () => {
        socketRef.current.disconnect();
      };
    }
  }, [tripId, dispatch]);

  const emitTripUpdate = (tripData) => {
    if (socketRef.current) {
      socketRef.current.emit('trip-update', {
        tripId,
        trip: tripData
      });
    }
  };

  return { emitTripUpdate };
};

export default useSocket;